module.exports = __webpack_public_path__ + "static/media/contest-match-icon.55220a4d.svg";